import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=1dc82d83&scoped=true&lang=html&"
import script from "./teamInfo.vue?vue&type=script&lang=ts&"
export * from "./teamInfo.vue?vue&type=script&lang=ts&"
import style0 from "./teamInfo.vue?vue&type=style&index=0&id=1dc82d83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc82d83",
  null
  
)

export default component.exports